// @flow

import styles from './ReportJobForm.less';
import React, { Component } from 'react';

import {
  Button,
  ButtonGroup,
  EmailField,
  Dropdown,
  Textarea
} from 'seek-style-guide/react';
import { withForm, Field } from '@seek/forms-ui';
import { required, isEmail } from '@seek/validators-js';

// Validation Rules
const emailRequired = {
  ...required,
  getErrorMessage: () => 'We need an email address to get back to you.'
};
const reasonRequired = {
  ...required,
  getErrorMessage: () => 'We need a reason for reporting this job.'
};

// Component configuration
const reasons = [
  { label: 'Broken and I cannot apply!!' },
  { label: 'Fraudulent' },
  { label: 'Poorly Classified' },
  { label: 'Offensive / Misleading' },
  { label: 'Other' }
].map((option, index) => ({ ...option, value: index.toString() }));

type TextareaProps = {
  count: number,
  show: boolean
};

const MAXIMUM_COMMENT_LENGTH = 400;
const countFeedback = (value: string): TextareaProps => {
  return {
    count: MAXIMUM_COMMENT_LENGTH - value.length,
    show: true
  };
};

type Props = {
  jobId: number,
  email?: string,
  submit: Function,
  cancel: Function,
  handleSubmit: Function
};

class ReportJobForm extends Component<Props> {
  submit = ({ reason, email: formEmail, ...formValues }: FraudReport): void => {
    const { jobId, email } = this.props;

    this.props.submit({
      jobId,
      email: email || formEmail,
      ...formValues,
      reason: reasons[parseInt(reason, 10)].label
    });
  };

  render() {
    const { handleSubmit, cancel, email } = this.props;

    return (
      <form
        onSubmit={handleSubmit(this.submit)}
        data-automation="report-job-ad-form"
      >
        {!email && (
          <Field
            form="reportJobForm"
            id="email"
            label="Your email address:"
            messageProps={{
              'data-automation': 'report-job-ad-email-message'
            }}
            inputProps={{
              'data-automation': 'report-job-ad-email'
            }}
            render={EmailField}
            validators={[emailRequired, isEmail]}
          />
        )}
        <Field
          form="reportJobForm"
          id="reason"
          label="Reason for reporting job:"
          placeholder="Please select"
          messageProps={{
            'data-automation': 'report-job-ad-reason-message'
          }}
          inputProps={{
            'data-automation': 'report-job-ad-reason'
          }}
          options={reasons}
          render={Dropdown}
          validators={[reasonRequired]}
        />
        <Field
          form="reportJobForm"
          id="comment"
          countFeedback={countFeedback}
          label="Additional Comments:"
          className={styles.field}
          inputProps={{
            'data-automation': 'report-job-ad-comment'
          }}
          maxLength={MAXIMUM_COMMENT_LENGTH}
          render={Textarea}
        />
        <ButtonGroup>
          <Button
            color="gray"
            type="submit"
            data-automation="report-job-ad-submit"
          >
            Report job
          </Button>
          <Button
            color="transparent"
            data-automation="report-job-ad-cancel"
            onClick={cancel}
          >
            Cancel
          </Button>
        </ButtonGroup>
      </form>
    );
  }
}

export default withForm({
  name: 'reportJobForm',
  initialValues: {
    email: '',
    reason: '',
    comment: ''
  }
})(ReportJobForm);
